import React from "react";
import { motion } from "framer-motion";
import { Container, Eyebrow, RevealHeading, PillButton } from "@/components/primitives";

export const PageHero = ({ eyebrow, title, copy, cta, ctaTo = "/contact", image, kicker }) => {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section className="relative overflow-hidden bg-govx-black text-govx-paper grain pt-[74px]">
      <Container className="relative z-10 grid gap-12 py-20 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:py-28">
        <div>
          <Eyebrow dark>{eyebrow}</Eyebrow>
          <RevealHeading
            lines={lines}
            className="mt-7 font-display text-4xl font-medium leading-[1.02] tracking-tight text-balance sm:text-5xl lg:text-6xl"
          />
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.35 }}
            className="mt-7 max-w-xl text-base leading-relaxed text-govx-grey sm:text-lg"
          >
            {copy}
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="mt-9"
          >
            <PillButton to={ctaTo} data-testid="page-hero-cta">{cta}</PillButton>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden border border-white/10">
            <img src={image} alt={eyebrow} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-govx-black/70 via-transparent to-transparent" />
            {kicker && (
              <div className="absolute bottom-0 left-0 right-0 border-t border-white/10 bg-govx-black/60 p-5 backdrop-blur-md">
                <span className="font-mono text-[0.7rem] uppercase tracking-[0.18em] text-govx-lime">
                  {kicker}
                </span>
              </div>
            )}
          </div>
          <div className="absolute -left-4 -top-4 -z-0 h-24 w-24 border-l border-t border-govx-green/50" />
          <div className="absolute -bottom-4 -right-4 -z-0 h-24 w-24 border-b border-r border-govx-green/50" />
        </motion.div>
      </Container>
    </section>
  );
};
